import React, {useMemo} from "react";
import PreFooter from "@components/Prefooter/PreFooter";
import PageSection from "@components/Page/PageSection";
import {findFirstSection, getCmsPage} from "@lib/Cms/CmsUtils";
import {SECTION_TYPE} from "@lib/Cms/CmsModels";
import BoostsPreview from "@components/Boost/BoostsPreview/BoostsPreview";
import KvBanner from "@components/KvBanner/KvBanner";
import {NavLink} from "react-router-dom";
import {buildLinkUrl} from "@router/RouterUtils";
import {ChevronRightIcon} from "@components/Icons/ChevronRightIcon";
import {assetFullPath} from "@commons/Utils";
import Page from "@components/Page/Page";
import PageContent from "@components/Page/PageContent";

export default function HowToPage() {

    const {sections, banner} = useMemo(() => getCmsPage("howTo") ?? {}, []);

    const defaultSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.DEFAULT), [sections]);
    const defaultSectionCta = defaultSection?.cta?.[0];
    const defaultSectionImage = defaultSection?.image?.[0];

    const boostSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.BOOSTS_PREVIEW), [sections]);
    const preFooterSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.PRE_FOOTER), [sections]);

    return (
        <>
            <Page>

                {!!banner &&
                    <KvBanner name={"how-to"} banner={banner} pushDown/>
                }

                <PageContent>

                    <PageSection bg={defaultSection?.options?.bgType}>

                        <div className="welcome-content howto-content reverse-mobile-order">
                            <div className="welcome-content__content">
                                {defaultSection?.title &&
                                    <h2 className={"tp-2xl semibold"}
                                        dangerouslySetInnerHTML={{__html: defaultSection.title}}/>
                                }

                                {defaultSection?.text &&
                                    <p className={"tp-s"} dangerouslySetInnerHTML={{__html: defaultSection.text}}/>
                                }
                                {!!defaultSectionCta &&
                                    <div className={"welcome-content__actions"}>
                                        <NavLink to={buildLinkUrl(defaultSectionCta.scope)}
                                                 className={"cta cta--medium"}>
                                                <span className="label">
                                                    {defaultSectionCta.title}
                                                </span>
                                            <span className="icon">
                                                    <ChevronRightIcon/>
                                                </span>
                                        </NavLink>
                                    </div>
                                }
                            </div>
                            {!!defaultSectionImage?.src &&
                                <div className="welcome-content__media">
                                    <img src={assetFullPath(defaultSectionImage.src)} alt=""/>
                                </div>
                            }
                        </div>

                    </PageSection>

                    {!!boostSection && <BoostsPreview cms={boostSection}/>}

                </PageContent>

            </Page>

            {!!preFooterSection && <PreFooter cms={preFooterSection}/>}

        </>
    );
}
